import * as Yup from 'yup';

const UserBalanceShema = Yup.object().shape({
  sum: Yup.string()
    .test('is-nnumber', 'Incorrect credits', function (value) {
      return !isNaN(+value);
    })
    .required('Credits is required'),
  message: Yup.string(),
  exchangeRate: Yup.string()
    .test('is-nnumber', 'Incorrect credits', function (value) {
      return !isNaN(+value);
    })
    .required('Rate is required'),
});

export default UserBalanceShema;
